import { __generator } from "tslib";
import React from 'react';
import { Trans } from 'react-i18next';
import { call, put, select, race, take } from 'redux-saga/effects';
import { request } from '../../xhr';
import { getCurrentGallection, getGallectionById } from '../selectors';
import { deselectAll } from '../actions';
import setGallectionCover from './setGallectionCover';
import updateGallectionSize from './updateGallectionSize';
import { isPremiumGallection, getPremiumGallectionType, } from '../../utils/gallections';
import { pushGlobalConfirmationModalForMM, confirmYes, confirmNo, } from '../../Modals/redux/actionCreators';
import { Warning } from '@wix/da-ds/pkg/Icons/Confirmations';
import { checkAndWarnIfDeviationsAreNotSupportedForPremium } from './helpers';
import { getGallectionType } from '../helpers';
export default function (action) {
    var _a, deviations, targetFolderId, _b, currentGallection, targetGallection, type, isFromPremiumFolder, isToPremiumFolder, hasUnsupportedDeviationSelected, premiumType, confirmationTextTransKey, no, deviationIds, params;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = action.payload, deviations = _a.deviations, targetFolderId = _a.targetFolderId;
                return [4 /*yield*/, select(function (state) { return ({
                        currentGallection: getCurrentGallection(state),
                        targetGallection: getGallectionById(state, targetFolderId),
                    }); })];
            case 1:
                _b = _c.sent(), currentGallection = _b.currentGallection, targetGallection = _b.targetGallection;
                type = getGallectionType(currentGallection);
                if (!currentGallection || !targetGallection || !type || type === 'stash') {
                    return [2 /*return*/];
                }
                isFromPremiumFolder = isPremiumGallection(currentGallection);
                isToPremiumFolder = isPremiumGallection(targetGallection);
                if (!(!isFromPremiumFolder && isToPremiumFolder)) return [3 /*break*/, 5];
                return [4 /*yield*/, call(checkAndWarnIfDeviationsAreNotSupportedForPremium, deviations)];
            case 2:
                hasUnsupportedDeviationSelected = _c.sent();
                if (hasUnsupportedDeviationSelected) {
                    return [2 /*return*/];
                }
                premiumType = getPremiumGallectionType(targetGallection);
                confirmationTextTransKey = void 0;
                if (premiumType === 'paid') {
                    confirmationTextTransKey = (React.createElement(Trans, { i18nKey: "mediapopup.confirmationPopup.moveDeviation.text.fromRegularToPaid" },
                        "\u2022 Only your paying Supporters will have access to it.",
                        React.createElement("br", null),
                        "\u2022 It will become locked for all your non-Supporters and will affect Collections, Groups, Profile Spotlights,",
                        ' ',
                        React.createElement("a", { href: "https://www.deviantartsupport.com/en/article/what-happens-when-i-move-deviations-in-or-out-of-premium-galleries" }, "and more"),
                        ".",
                        React.createElement("br", null),
                        "\u2022 Prints and Premium Downloads will be disabled.",
                        React.createElement("br", null),
                        React.createElement("br", null),
                        "Are you sure you want to move this deviation?"));
                }
                else {
                    confirmationTextTransKey = (React.createElement(Trans, { i18nKey: "mediapopup.confirmationPopup.moveDeviation.text.fromRegularToWatchersOnly" },
                        "\u2022 Only your watchers will have access to it.",
                        React.createElement("br", null),
                        "\u2022 It will become locked for deviants who don\u2019t watch you and will affect Collections, Groups, Profile Spotlights,",
                        ' ',
                        React.createElement("a", { href: "https://www.deviantartsupport.com/en/article/what-happens-when-i-move-deviations-in-or-out-of-premium-galleries" }, "and more"),
                        ".",
                        React.createElement("br", null),
                        "\u2022 Prints and Premium Downloads will be disabled.",
                        React.createElement("br", null),
                        React.createElement("br", null),
                        "Are you sure you want to move this deviation?"));
                }
                return [4 /*yield*/, put(pushGlobalConfirmationModalForMM({
                        titleTransKey: 'mediapopup.confirmationPopup.moveDeviation.title',
                        textTransKey: confirmationTextTransKey,
                        confirmBtnLabelTransKey: 'mediapopup.confirmationPopup.moveDeviation.confirm',
                        cancelBtnLabelTransKey: 'popup.cancel',
                        icon: React.createElement(Warning, null),
                    }))];
            case 3:
                _c.sent();
                return [4 /*yield*/, race({
                        yes: take(confirmYes),
                        no: take(confirmNo),
                    })];
            case 4:
                no = (_c.sent()).no;
                if (no) {
                    return [2 /*return*/];
                }
                _c.label = 5;
            case 5: return [4 /*yield*/, put(deselectAll())];
            case 6:
                _c.sent();
                return [4 /*yield*/, call(setGallectionCover, {
                        gallection: targetGallection,
                        deviation: deviations[0],
                        onlyIfMissing: true,
                    })];
            case 7:
                _c.sent();
                return [4 /*yield*/, call(updateGallectionSize, targetFolderId, deviations.length)];
            case 8:
                _c.sent();
                deviationIds = deviations.map(function (deviation) { return deviation.deviationId; });
                params = {
                    type: type,
                    target_folderid: targetFolderId,
                    deviationids: deviationIds,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'gallection/folders/copy_deviations',
                        data: params,
                    })];
            case 9:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=copyDeviations.js.map